import { Grid as MuiGrid, GridProps as MuiGridProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import ArchLogo from '@Assets/images/arch-logo.svg';
import LoginBackground from '@Assets/images/Login-background-arrows.svg';

export const Container = styled(MuiGrid)<MuiGridProps>(
  ({ theme: { spacing, customVars } }) => ({
    flexWrap: 'nowrap',
    overflowY: 'auto',
    minHeight: '100vh',
    position: 'relative',
    '& .infoPanel': {
      padding: spacing(12.3, 1),
      background: customVars.gradient,
    },

    '& .loginPanel': {
      padding: spacing(12.3, 1, 1),
      background: `no-repeat bottom right url(${LoginBackground})`,
    },
  })
);

export const LogoContainer = styled('div')(({ theme: { spacing } }) => ({
  minWidth: spacing(35.2),
  minHeight: spacing(4.5),
  background: `url(${ArchLogo}) no-repeat center left`,
  marginBottom: spacing(2.9),
}));
